(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TermsConditionsController', TermsConditionsController);

    TermsConditionsController.$inject = ['$state', '$uibModalInstance', '$window', 'User', 'AlertService'];

    function TermsConditionsController($state, $uibModalInstance, $window, User, AlertService) {
        var vm = this;

        var termsUrl = "./content/terms-privacy/terms-conditions.pdf";
        var privacyUrl = "./content/terms-privacy/privacy.pdf";

        vm.checkTerms = false;
        vm.checkPrivacy = false;
        vm.check1 = false;
        vm.disabled = true;
        vm.checkDisabled = "Please view both links";

        vm.save = function () {
            $uibModalInstance.close();

            User.setTerms(vm.updateCheck, onSuccess, onError);

            function onSuccess(data, headers) {
                $uibModalInstance.close();
            }

            function onError() {
                $state.reload();
            }
        };

        vm.termsAgree = function() {
            $window.open(termsUrl);
            vm.checkTerms = true;
            if(vm.checkTerms && vm.checkPrivacy){
                vm.disabled = false;
                vm.checkDisabled = "";
            }
        };

        vm.privacyAgree = function() {
            $window.open(privacyUrl);
            vm.checkPrivacy = true;
            if(vm.checkTerms && vm.checkPrivacy){
                vm.disabled = false;
                vm.checkDisabled = "";
            }
        };

    }
})();
